import React from 'react';
import { FormControl } from 'react-bootstrap';

export function PageSize({ totalRows, options, onPageSizeChange }) {
    if (totalRows < 1) {
        return null;
    }

    return (
        <FormControl
            bsSize="small"
            componentClass="select"
            style={{ width: '75px' }}
            onChange={(e) => onPageSizeChange(e.target.value)}
        >            
            {options.map((option) =>
                <option
                    key={option.value}
                    value={option.value}
                >                    
                    {option.text}                    
                </option>
            )}
        </FormControl>
    );
}
